
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as R from 'ramda';
import { deleteClient } from '../../actions/backoffice/clients';


export const DeleteUser = ({ selectedUser, deleteUser }) => {

	const user = useSelector(state => state.user);

	const dispatch = useDispatch();



	return (
		<div className="modal fade px-0" id="deleteUser" aria-labelledby="deleteUserLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-danger rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Delete user</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-danger text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="deleteUserLabel">Supprimer l'utilisateur</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body text-center">
						<div className={"d-flex mx-auto h-avatar w-avatar rounded font-weight-bold mb-2 bg-light text-danger"}>
							<i className="eva eva-trash-2-outline h2 lh-1 m-auto icon-default"></i>
						</div>
						<div className="fs-sm ls-n1">Etes-vous sûr(e) de vouloir supprimer la compte <strong>{selectedUser.firstName} {selectedUser.lastName}</strong>?</div>
						<div className="fs-3 o-60">Cette action est irréversible.</div>
					</div>
					<div className="modal-footer justify-content-center">
						<button type="button" className="btn btn-light" data-dismiss="modal" aria-label="Close">Annuler</button>
						<button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => deleteUser(selectedUser)}>Supprimer</button>
					</div>
				</div>
			</div>
		</div>
	);
};